import { HelmetProps, useSetTags } from '@breathelife/react-hooks';

export function Helmet(props: HelmetProps): null {
  useSetTags(props);
  return null;
}
